import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {catchError, finalize} from 'rxjs/operators';
import {FaxLogModel} from '../../../api/models/fax-log-model';
import {FaxReportService as FaxReportsApiService} from '../../../api/services/fax-report.service';
import {FaxLogsRequest} from '../../../api/models/fax-logs-request';
import {FaxLogsResponse} from '../../../api/models/fax-logs-response';


export class FaxLogsDatasource implements DataSource<FaxLogModel> {

  constructor(private faxReportsService: FaxReportsApiService) {
  }

  private dataSubject = new BehaviorSubject<FaxLogModel[]>([]);
  private dataTotalSubject = new BehaviorSubject<number>(0);
  private loadingSubject = new BehaviorSubject<boolean>(true);

  public loading$ = this.loadingSubject.asObservable();
  public dataCount$ = this.dataTotalSubject.asObservable();

  connect(collectionViewer: CollectionViewer): Observable<FaxLogModel[] | ReadonlyArray<FaxLogModel>> {
    console.log('Connecting data source');
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    console.log('Disconnecting data source');
    this.dataSubject.complete();
    this.loadingSubject.complete();
    this.dataTotalSubject.complete();
  }

  public currentPageData(): FaxLogModel[] {
    return this.dataSubject.getValue();
  }

  public queryData(state: FaxLogsRequest): void {
    console.log('query audit items');
    this.loadingSubject.next(true);

    this.faxReportsService
      .faxReportGetLogs({body: state})
      .pipe(
        catchError(() => of({data: [], total: 0})),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe((response: FaxLogsResponse) => {
        this.dataTotalSubject.next(response.total);
        this.dataSubject.next(response.data);
      });
  }
}
